export const AppOverviewDataHooks = {
  LEARN_MORE_BUTTON: 'app-overview-learn-more-button',
  BENEFITS_LIST: 'app-overview-benefits-list',
  APP_NAME_HEADER: 'app-overview-name-header',
  INFORMATION_COLLAPSIBLE: 'app-overview-information-collapsible',
  INFORMATION_NON_COLLAPSIBLE: 'app-overview-information-non-collapsible',
  LEAN_OVERVIEW_DESCRIPTION: 'app-overview-description',
  OVERVIEW_CONTAINER: 'overview-container',
  DEMO_URL: 'app-overview-demo-url',
};
